export function splitMatch(text: string, query: string) {
  const needle = query.trim();
  if (!needle) return null;
  const index = text.toLowerCase().indexOf(needle.toLowerCase());
  if (index === -1) return null;
  return {
    before: text.slice(0, index),
    match: text.slice(index, index + needle.length),
    after: text.slice(index + needle.length),
  };
}
